import APP from 'src/main.js'
import AppRecord from './AppRecord.js'

class EntityBenchmark extends AppRecord {
  get benchmark_setups(){
    return this.constructor.employeeStore.benchmark_setups.filter(bms => bms.entity_benchmark_id === this.id)
  }

  get benchmarkWeightsValidForAllocation(){
    return this.benchmark_setups.every(x => x.benchmarkWeightsValidForAllocation)
  }
}

export default EntityBenchmark
